<div>
  <div
    class="match-type"
    [class.open]="open$ | async"
    [class.no-label]="controlWithoutLabel"
    [class.input-group]="inputGroup"
    (click)="menu.toggle($event)"
    pTooltip="{{ labelText$ | async }}<br />{{ titleText$ | async }}"
    [showDelay]="250"
    [escape]="false"
  >
    <span>{{ labelText$ | async }}</span>
    <i class="fa-regular fa-angle-down"></i>
  </div>

  <p-menu
    #menu
    [popup]="true"
    appendTo="body"
    [model]="items$ | async"
    (onShow)="onShow($event)"
    (onHide)="onHide($event)"
    styleClass="match-type-popup"
  ></p-menu>
</div>
